module.exports = __webpack_public_path__ + "img/olimpiya-mobile.9b391f64.jpg";